import React from 'react';
import { PropTypes } from 'prop-types';

import './video.scss';
import './wistia.scss';

const VideoHero = ({ wistiaID }) => {
  const cookies = typeof window !== 'undefined' ? window.OptanonActiveGroups : false;
  const performanceCookieOn = cookies ? cookies.split(',').indexOf('2') !== -1 : true;
  return performanceCookieOn ? (
    <div className='video-hero'>
      <div className='wistia_responsive_padding'>
        <div className='wistia_responsive_wrapper'>
          <iframe
            src={`https://fast.wistia.net/embed/iframe/${wistiaID}?videoFoam=true`}
            title='Fresh Fund Compilation - (with captions) Video'
            allow='autoplay; fullscreen'
            allowtransparency='true'
            frameBorder='0'
            scrolling='no'
            className='wistia_embed'
            name='wistia_embed'
            allowFullScreen
            data-msallowfullscreen
            width='100%'
            height='100%'
          />
        </div>
      </div>
    </div>
  ) : (
    <div className='privacy-settings-update'>
      Please update your privacy settings to enable video play.
    </div>
  );
};

VideoHero.defaultProps = {
  wistiaID: 'iyj7ysbh3u',
};

VideoHero.propTypes = {
  wistiaID: PropTypes.string,
};

export default VideoHero;
